/**
 * 拍卖状态枚举
 */
export default [
    {key: 10, value: '未开始'},
    {key: 20, value: '进行中'},
    {key: 30, value: '已结束'},
]
